
import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

const galleryImages = [
  {
    src: 'https://public.readdy.ai/ai/img_res/bcc036fd021d37f916c8027624fd5210.jpg',
    title: 'Spawanie konstrukcji nośnej',
    category: 'Spawalnictwo',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=finished%20painted%20steel%20bridge%20structure%20in%20industrial%20workshop%20red%20oxide%20primer%20coating%20heavy%20steel%20fabrication%20professional%20photography%20dark%20factory%20interior%20with%20overhead%20crane%20blue%20atmospheric%20lighting%20photorealistic%208k%20quality%20no%20text%20no%20logo&width=800&height=600&seq=real-gallery-002&orientation=landscape',
    title: 'Konstrukcja mostowa — montaż',
    category: 'Konstrukcje Mostowe',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=CNC%20plasma%20cutting%20thick%20steel%20plate%20in%20dark%20industrial%20workshop%20bright%20orange%20sparks%20and%20molten%20metal%20flying%20precision%20cutting%20of%20complex%20shapes%20professional%20industrial%20photography%20blue%20ambient%20lighting%20photorealistic%208k%20quality%20no%20text%20no%20logo&width=800&height=600&seq=real-gallery-003&orientation=landscape',
    title: 'Cięcie plazmowe CNC',
    category: 'Obróbka',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=large%20industrial%20steel%20staircase%20structure%20freshly%20fabricated%20in%20workshop%20with%20yellow%20safety%20paint%20markings%20heavy%20duty%20steel%20construction%20professional%20photography%20dark%20factory%20setting%20blue%20tinted%20lighting%20photorealistic%208k%20quality%20no%20text%20no%20logo&width=800&height=600&seq=real-gallery-004&orientation=landscape',
    title: 'Schody i podesty przemysłowe',
    category: 'Konstrukcje Stalowe',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=steel%20pipe%20welding%20close%20up%20TIG%20welding%20with%20perfect%20bead%20on%20stainless%20steel%20pipe%20bright%20blue%20welding%20arc%20professional%20industrial%20macro%20photography%20dark%20background%20photorealistic%208k%20quality%20no%20text%20no%20logo&width=800&height=600&seq=real-gallery-005&orientation=landscape',
    title: 'Spawanie rur ciśnieniowych TIG',
    category: 'Spawalnictwo',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=massive%20steel%20industrial%20platform%20structure%20assembled%20in%20factory%20hall%20with%20overhead%20gantry%20crane%20workers%20in%20safety%20gear%20professional%20industrial%20photography%20dark%20moody%20atmosphere%20blue%20atmospheric%20lighting%20photorealistic%208k%20quality%20no%20text%20no%20logo&width=800&height=600&seq=real-gallery-006&orientation=landscape',
    title: 'Platforma przemysłowa — hala',
    category: 'Konstrukcje Stalowe',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=steel%20structure%20being%20sandblasted%20and%20anti%20corrosion%20coated%20in%20industrial%20paint%20booth%20professional%20surface%20treatment%20workshop%20dark%20environment%20with%20bright%20work%20lights%20blue%20tinted%20atmosphere%20photorealistic%208k%20quality%20no%20text%20no%20logo&width=800&height=600&seq=real-gallery-007&orientation=landscape',
    title: 'Piaskowanie i malowanie',
    category: 'Zabezpieczenia',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=heavy%20steel%20conveyor%20frame%20structure%20being%20assembled%20in%20industrial%20workshop%20with%20precision%20measuring%20tools%20and%20welding%20equipment%20professional%20industrial%20photography%20dark%20factory%20blue%20atmospheric%20lighting%20photorealistic%208k%20quality%20no%20text%20no%20logo&width=800&height=600&seq=real-gallery-008&orientation=landscape',
    title: 'Rama przenośnika taśmowego',
    category: 'Konstrukcje Stalowe',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=industrial%20steel%20tank%20vessel%20being%20fabricated%20in%20workshop%20large%20cylindrical%20pressure%20vessel%20with%20welded%20seams%20professional%20industrial%20photography%20dark%20moody%20factory%20interior%20blue%20lighting%20photorealistic%208k%20quality%20no%20text%20no%20logo&width=800&height=600&seq=real-gallery-009&orientation=landscape',
    title: 'Zbiornik ciśnieniowy — produkcja',
    category: 'Zbiorniki',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=completed%20steel%20roof%20truss%20structure%20loaded%20on%20truck%20for%20transport%20from%20industrial%20workshop%20professional%20photography%20dark%20factory%20exterior%20twilight%20blue%20hour%20lighting%20photorealistic%208k%20quality%20no%20text%20no%20logo&width=800&height=600&seq=real-gallery-010&orientation=landscape',
    title: 'Kratownice dachowe — transport',
    category: 'Konstrukcje Mostowe',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=quality%20control%20inspector%20checking%20steel%20welds%20with%20ultrasonic%20testing%20equipment%20in%20dark%20industrial%20workshop%20professional%20industrial%20photography%20blue%20atmospheric%20lighting%20photorealistic%208k%20quality%20no%20text%20no%20logo&width=800&height=600&seq=real-gallery-011&orientation=landscape',
    title: 'Kontrola jakości spoin',
    category: 'Kontrola Jakości',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=steel%20industrial%20handrail%20and%20railing%20system%20freshly%20welded%20and%20ground%20smooth%20in%20factory%20workshop%20professional%20metalwork%20photography%20dark%20environment%20blue%20tinted%20lighting%20photorealistic%208k%20quality%20no%20text%20no%20logo&width=800&height=600&seq=real-gallery-012&orientation=landscape',
    title: 'Balustrady i barierki stalowe',
    category: 'Konstrukcje Stalowe',
  },
];

const categories = ['Wszystkie', ...Array.from(new Set(galleryImages.map((img) => img.category)))];

export default function RealizationsGallery() {
  const [ref, isInView] = useInView({ threshold: 0.05 });
  const [activeCategory, setActiveCategory] = useState('Wszystkie');
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const filtered =
    activeCategory === 'Wszystkie'
      ? galleryImages
      : galleryImages.filter((img) => img.category === activeCategory);

  const openLightbox = (index: number) => setLightboxIndex(index);
  const closeLightbox = () => setLightboxIndex(null);

  const goNext = () => {
    if (lightboxIndex === null) return;
    setLightboxIndex((lightboxIndex + 1) % filtered.length);
  };

  const goPrev = () => {
    if (lightboxIndex === null) return;
    setLightboxIndex((lightboxIndex - 1 + filtered.length) % filtered.length);
  };

  return (
    <>
      <section ref={ref} className="relative py-20 sm:py-32 bg-[#050505] overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00E5FF]/20 to-transparent" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="text-center mb-10 sm:mb-14"
          >
            <span
              className="text-[#00E5FF] text-xs tracking-[0.3em] uppercase font-semibold"
              style={{ fontFamily: 'Orbitron, sans-serif' }}
            >
              Realizacje
            </span>
            <h2
              className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mt-4 leading-tight"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
            >
              Galeria <span className="text-[#00E5FF]">z Zakładu</span>
            </h2>
            <p
              className="text-[#C0C7CF] text-sm sm:text-base mt-4 max-w-2xl mx-auto"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Prawdziwe zdjęcia z naszego zakładu produkcyjnego — spawanie, montaż,
              obróbka i kontrola jakości konstrukcji stalowych.
            </p>
          </motion.div>

          {/* Filtry kategorii */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-10 sm:mb-14"
          >
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-4 py-2 text-[10px] sm:text-xs tracking-[0.15em] uppercase font-semibold border transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  activeCategory === cat
                    ? 'bg-[#00E5FF] text-[#050505] border-[#00E5FF]'
                    : 'bg-transparent text-[#C0C7CF] border-[#333] hover:border-[#00E5FF]/50 hover:text-[#00E5FF]'
                }`}
                style={{ fontFamily: 'Orbitron, sans-serif' }}
              >
                {cat}
              </button>
            ))}
          </motion.div>

          {/* Grid zdjęć */}
          <motion.div
            layout
            className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4"
          >
            <AnimatePresence mode="popLayout">
              {filtered.map((img, index) => (
                <motion.div
                  key={img.src}
                  layout
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ duration: 0.4, delay: index * 0.04 }}
                  className={`group relative overflow-hidden cursor-pointer ${
                    index === 0 ? 'md:col-span-2 md:row-span-2' : ''
                  }`}
                  onClick={() => openLightbox(index)}
                >
                  <div className={`relative w-full ${index === 0 ? 'h-64 sm:h-80 md:h-full min-h-[300px]' : 'h-44 sm:h-52'} overflow-hidden`}>
                    <img
                      src={img.src}
                      alt={img.title}
                      title={`${img.title} — EUREKA konstrukcje stalowe`}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />

                    <div className="absolute inset-0 flex flex-col justify-end p-3 sm:p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-400">
                      <span
                        className="text-[#00E5FF] text-[8px] sm:text-[9px] tracking-[0.2em] uppercase font-semibold mb-1"
                        style={{ fontFamily: 'Orbitron, sans-serif' }}
                      >
                        {img.category}
                      </span>
                      <span
                        className="text-white text-sm sm:text-base font-bold leading-tight"
                        style={{ fontFamily: 'Rajdhani, sans-serif' }}
                      >
                        {img.title}
                      </span>
                    </div>

                    <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-[#00E5FF] text-[#050505] opacity-0 group-hover:opacity-100 transition-all duration-300 group-hover:scale-100 scale-75">
                      <i className="ri-zoom-in-line text-base" />
                    </div>
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>

      {/* Lightbox */}
      <AnimatePresence>
        {lightboxIndex !== null && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 z-[9999] bg-black/95 flex items-center justify-center"
            onClick={closeLightbox}
          >
            <button
              onClick={(e) => {
                e.stopPropagation();
                closeLightbox();
              }}
              className="absolute top-4 right-4 sm:top-6 sm:right-6 w-10 h-10 flex items-center justify-center text-white/70 hover:text-[#00E5FF] transition-colors cursor-pointer z-10"
              aria-label="Zamknij"
            >
              <i className="ri-close-line text-3xl" />
            </button>

            <button
              onClick={(e) => {
                e.stopPropagation();
                goPrev();
              }}
              className="absolute left-2 sm:left-6 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-white/5 border border-white/10 text-white/70 hover:text-[#00E5FF] hover:border-[#00E5FF]/50 transition-all cursor-pointer rounded-full z-10"
              aria-label="Poprzednie zdjęcie"
            >
              <i className="ri-arrow-left-s-line text-2xl" />
            </button>

            <button
              onClick={(e) => {
                e.stopPropagation();
                goNext();
              }}
              className="absolute right-2 sm:right-6 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-white/5 border border-white/10 text-white/70 hover:text-[#00E5FF] hover:border-[#00E5FF]/50 transition-all cursor-pointer rounded-full z-10"
              aria-label="Następne zdjęcie"
            >
              <i className="ri-arrow-right-s-line text-2xl" />
            </button>

            <motion.div
              key={lightboxIndex}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.3 }}
              className="max-w-5xl w-full mx-4 sm:mx-8"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="relative w-full h-[50vh] sm:h-[70vh] overflow-hidden">
                <img
                  src={filtered[lightboxIndex].src}
                  alt={filtered[lightboxIndex].title}
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="mt-4 text-center">
                <span
                  className="text-[#00E5FF] text-[9px] sm:text-[10px] tracking-[0.2em] uppercase font-semibold"
                  style={{ fontFamily: 'Orbitron, sans-serif' }}
                >
                  {filtered[lightboxIndex].category}
                </span>
                <h3
                  className="text-white text-lg sm:text-xl font-bold mt-1"
                  style={{ fontFamily: 'Rajdhani, sans-serif' }}
                >
                  {filtered[lightboxIndex].title}
                </h3>
                <p
                  className="text-[#888] text-xs mt-2"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  {lightboxIndex + 1} / {filtered.length}
                </p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
